module.exports = __webpack_public_path__ + "static/media/navi-bg-asuminen.36a1fdcb.svg";